import { jwtDecode } from 'jwt-decode'

export function GetUrlParameter(aUrl, aParamKey)
{
  let Index = aUrl.indexOf("?" + aParamKey + "=")
  if (Index < 1) { Index = aUrl.indexOf("&" + aParamKey + "=") }
    
  if (Index > 0)
  {
    aUrl = aUrl.substring(Index + aParamKey.length + 2)

    Index = aUrl.indexOf("&")
    return (Index > 0) ? aUrl.substring(0,Index) : aUrl
  }
  else
  {
    return ""
  }
}

export function GetDelphiDateTimeNow()
{
  return (new Date().getTime()) / (24 * 60 * 60 * 1000) + 25569 
}

export function IsEmptyString(aString)  
{
    return aString === undefined
        || aString === null
        || !aString
}

export function ExtractParamFromSecurityToken(aSecurityToken,aParamId)
{
    const DecodedToken = jwtDecode(aSecurityToken)
    return  DecodedToken[aParamId]
}

export async function UploadFileWithProgress(aFile, aUploadUrl, aProgressEvent) //aProgressEvent should be a function with 1 string parameter, like a SetState
{
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open('PUT', aUploadUrl, true);
        xhr.setRequestHeader('x-ms-blob-type', 'BlockBlob');
        xhr.setRequestHeader('Content-Type', aFile.type);

        xhr.upload.onprogress = (event) => 
        {
            if (event.lengthComputable) 
            {
                const percentComplete = Math.round((event.loaded / event.total) * 100);
                aProgressEvent("Uploading file... " + percentComplete + "%"); // Update progress every time event fires
            }
        };

        xhr.onload = () => 
        {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error(`Upload failed with status ${xhr.status}`));
            }
        };

        xhr.onerror = () => reject(new Error('Upload failed due to a network error'));

        xhr.send(aFile);
    });
}